import { Controller } from "@hotwired/stimulus"

// Anime un donut chart SVG au chargement
// Usage: data-controller="progress-donut" data-progress-donut-percentage-value="65"
export default class extends Controller {
  static values = {
    percentage: { type: Number, default: 0 }
  }

  static targets = ["circle", "text"]

  connect() {
    this.animate()
  }

  animate() {
    const radius = 54
    const circumference = 2 * Math.PI * radius
    const offset = circumference - (this.percentageValue / 100) * circumference

    this.circleTarget.style.strokeDasharray = `${circumference}`
    this.circleTarget.style.strokeDashoffset = `${circumference}`

    requestAnimationFrame(() => {
      this.circleTarget.style.transition = "stroke-dashoffset 1s ease-in-out"
      this.circleTarget.style.strokeDashoffset = `${offset}`
    })

    this.animateCounter()
  }

  animateCounter() {
    const target = this.percentageValue
    const duration = 1000
    const start = performance.now()

    const step = (timestamp) => {
      const elapsed = timestamp - start
      const progress = Math.min(elapsed / duration, 1)
      const current = Math.round(progress * target)

      this.textTarget.textContent = `${current}%`

      if (progress < 1) {
        requestAnimationFrame(step)
      }
    }

    requestAnimationFrame(step)
  }
}
